export enum ExtensionStatusEnum {
    CANCELLED = 'CANCELLED',
    GRANTED = 'GRANTED'
}